import Vue from 'vue'
import detail from './detail.vue'
/* eslint-disable no-new */
new Vue({
  el: '#detail',
  render: h => h(detail)
})



//////////////////
// WEBPACK FOOTER
// ./public/detail/detail.js
// module id = null
// module chunks = 